.sprint-title {
	padding-right: var(--jpo-common-base-spacing);
}

.sprint-title-container {
	display: flex;
	align-items: center;
	max-width: calc(
		450px - calc(6 * var(--jpo-common-base-spacing)) - calc(1.5 * var(--jpo-icon-size-small))
	);
	text-overflow: ellipsis;
	overflow-x: 'hidden';
	flex-grow: 1;
	white-space: 'nowrap';
}

.checkboxWrapper {
	padding: 4px 4px 4px 8px;
	border-left: 2px transparent solid;

	&:hover {
		background-color: var(
			--ds-background-neutral-subtle-hovered,
			var(--adg3-color-N20-transparent)
		);
		border-left: 2px var(--ds-border-brand, var(--adg3-color-B100)) solid;
	}
}
